/**
 * Tabs
 * ======================================
 * - toggle class on tab nav item
 * - toggle hidden attribute on tabs
 * - html markup required (js-tabs-select, js-tabs-nav, js-tabs-list)
 * - support for mobile select
 * - support multiple widgets
 */

const ISMOBILE = window.matchMedia("only screen and (max-width: 991px)").matches
const WIDGET = '.js-TabsBookmarks'
const ACTIVECLASS = 'is-open'
const DEFAULTACTIVECLASS = 'is-open-default'

class TabsBookmarks {
  constructor() {
    this.elements = document.querySelectorAll(WIDGET)

    this.elements.forEach((el) => {
      const nav = el.querySelectorAll('.tabs-bookmarks__item-header')

      nav.forEach((navEl) => {
        navEl.addEventListener('click', this.clickHandler, false)
      })

      if(el.hasAttribute('data-mobile-close') && ISMOBILE){
        this.initClose(el)
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          this.initOpen(el)
        })
      }
    })
  }

  clickHandler = (e) => {
    const button = e.currentTarget
    const widget = button.closest(WIDGET)

    this.switchTab(widget, this.getIndex(button.closest('.tabs-bookmarks__item')))
  }


  initClose = (widget) => {
    const activeTab = widget.querySelector('.tabs-bookmarks__item.'+DEFAULTACTIVECLASS)

    activeTab.classList.remove(...[DEFAULTACTIVECLASS, ACTIVECLASS])
  }

  initOpen = (widget) => {
    const activeTab = widget.querySelector('.tabs-bookmarks__item.'+DEFAULTACTIVECLASS)

    this.setHeight(activeTab)

    activeTab.classList.remove(DEFAULTACTIVECLASS)
  }

  switchTab = (widget, index) => {
    const tabs = widget.querySelectorAll('.tabs-bookmarks__item')

    if (ISMOBILE) {
      tabs.forEach((tab) => {
        if (this.getIndex(tab) === index) {
          if(tab.classList.contains(ACTIVECLASS)){
            tab.classList.remove(ACTIVECLASS)
            this.setHeight(tab, true)
          } else {
            tab.classList.add(ACTIVECLASS)
            this.setHeight(tab)
          }
        }
      })
    } else {
      this.reset(widget)

      tabs.forEach((tab) => {
        if (this.getIndex(tab) === index) {
          tab.classList.add(ACTIVECLASS)
          this.setHeight(tab)
        }
      })
    }

    window.dispatchEvent(new CustomEvent('scroll'))
  }

  setHeight = (tab, close = false) => {
    const sub = tab.querySelector('.tabs-bookmarks__item-groups')

    if (ISMOBILE) {
      var height = sub.scrollHeight
      var heightEl = sub
    } else {
      var height = sub.scrollHeight + tab.querySelector('.tabs-bookmarks__item-header').scrollHeight
      var heightEl = sub.closest('.tabs-bookmarks')
    }

    if(close){
      heightEl.style.height = 0
    } else {
      heightEl.style.height = height + 'px'
    }
  }

  getIndex = (el) => {
    return [...el.parentNode.children].indexOf(el)
  }

  reset = (widget) => {
    const tabs = widget.querySelectorAll('.tabs-bookmarks__item')

    tabs.forEach((tab) => {
      tab.classList.remove(ACTIVECLASS)
    })
  }
}

new TabsBookmarks()
